import { Component, OnInit, ChangeDetectorRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '@services/auth.service';
import { Store } from '@models/store';
import { StackVendorsComponent } from './stack-vendors/stack-vendors.component';
import { StackTodoTodayComponent } from './stack-todo-today/stack-todo-today.component';

@Component({
  selector: 'app-managed-board-stack',
  templateUrl: './managed-board-stack.component.html',
  styleUrls: [
    '../managed-board.component.css',
    './managed-board-stack.component.css',
  ],
})
export class ManagedBoardStackComponent implements OnInit {
  @ViewChild(StackTodoTodayComponent) todoToday: StackTodoTodayComponent;
  @ViewChildren(StackVendorsComponent) vendorSections: QueryList<StackVendorsComponent>;
  storeSubscription: Subscription;
  currentStore: Store;
  todoTodayCount = 0;
  toOrderCustomerCount = 0;
  toRepairCount = 0;
  holdCount = 0;
  genericHoldCount = 0;
  awaitingFrameCount = 0;
  awaitingLensesCount = 0;
  awaitingRepairCount = 0;
  private refreshing = false;

  constructor(private auth: AuthService, private cdRef: ChangeDetectorRef) {
    this.storeSubscription = this.auth.getStoreObjectMessage().subscribe(
      (store: Store) => {
        this.currentStore = store;
      }
    );
  }

  ngOnInit(): void {
    this.currentStore = this.auth.getStoreObject();
  }

  get headerColor(): string {
    return this.currentStore?.headerColor || '#2e7d32';
  }

  onToOrderCounts(counts: { total: number; customer: number }): void {
    this.toOrderCustomerCount = counts.customer;
    this.cdRef.detectChanges();
  }

  refreshAll(): void {
    if (this.refreshing) {
      return;
    }
    this.refreshing = true;
    this.todoToday?.loadTasks();
    this.vendorSections?.forEach((section) => section.getNewOrders());
    setTimeout(() => {
      this.refreshing = false;
    }, 500);
  }
}
